// extracted by mini-css-extract-plugin
export default {"rating":"Wz-z","numberOfStars":"Xz-z","count":"Yz-z","barGraphSpacing":"Zz-z","barGraph":"_z-z"};